import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@material-ui/core";
import {  MdInbox } from "react-icons/md";
import { makeStyles } from '@material-ui/core/styles';
import classnames from "classnames";
import Tooltip from '@material-ui/core/Tooltip';
import IsMobileContext from "../../../context/isMobile/isMobileContext";
import ListaSoporte from '../ListaSoporte'

const useStyles = makeStyles(theme => ({
    link: {
      textDecoration: "none",
      "&:hover, &:focus": {
        backgroundColor: theme.palette.background.light,
      },
      //   para mover los iconos de sidebar hacia los costados
      paddingLeft:".3em",
    },
    linkActive: {
      backgroundColor: theme.palette.action.hover,
    },
    linkNested: {
      //paddingLeft: 0,
      "&:hover, &:focus": {
        backgroundColor: "#FFFFFF",
      },
    },
    linkIcon: {
      paddingRight: "1.2em",
      color: theme.palette.text.secondary + "99",
      transition: theme.transitions.create("color"),
      width: 24,
      display: "flex",
      flexDirection:"row",
      justifyContent: "center",
    },
    linkIconActive: {
      color: theme.palette.primary.main,
    },
    linkText: {
      padding: 0,
      color: theme.palette.text.secondary + "CC",
      transition: theme.transitions.create(["opacity", "color"]),
      fontSize: 16,
    },
    linkTextActive: {
      color: theme.palette.text.primary,
    },
    linkTextHidden: {
      opacity: 0,
    },
    nestedList: {
      paddingLeft: theme.spacing(2) + 30,
    },
    sectionTitle: {
      marginLeft: theme.spacing(4.5),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
      height: 1,
      backgroundColor: "#D8D8D880",
    },
  }));

const SidebarLink = ({
    link,
    icon,
    label,
    children,
    location,
    isSidebarOpened,
    nested,
    type,
}) => {
    const classes = useStyles();
    var [isOpen, setIsOpen] = useState(false);
    var isLinkActive = link && (location.pathname === link || location.pathname.indexOf(link) !== -1);
    const isMobile = useContext(IsMobileContext);
    const { isMobileUse } = isMobile;
    if (!isMobileUse()) { 
      // TITULO
      if (type === "title")
          return (
              <Typography>{label}</Typography>
          );
      // DIVISOR
      if (type === "divider") return <Divider />;
      //SIN SUB MENU
      if (!children)
          return (
              <Tooltip arrow title={<p style={{fontSize: "12px", minWidth: 70, textAlign:"center"}}>{label}</p>}aria-label="edit" aria-label="edit" placement="left">
                <ListItem
                  button
                  component={link && Link}
                  to={link}
                  className={classes.link}
                  classes={{
                      root: classnames(classes.linkRoot, {
                          [classes.linkActive]: isLinkActive && !nested,
                          [classes.linkNested]: nested,
                      }),
                  }}
                  disableRipple
              >
                  
                  <ListItemIcon
                      className={classnames(classes.linkIcon, {
                          [classes.linkIconActive]: isLinkActive,
                      })}
                  >                      
                      {icon ? icon : <></>}
                  </ListItemIcon>
                  <ListItemText
                      primary={label}
                  />
              </ListItem>
              </Tooltip>
          );
          // MENU CON SUB MENU
          return (
              <>
                <ListItem
                  button
                  component={link && Link}
                  onClick={toggleCollapse}
                  className={classes.link}
                  to={link}
                  disableRipple
                >
                  <ListItemIcon
                    className={classnames(classes.linkIcon, {
                      [classes.linkIconActive]: isLinkActive,
                    })}
                  >
                    {icon ? icon : <MdInbox />}
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: classnames(classes.linkText, {
                        [classes.linkTextActive]: isLinkActive
                      }),
                    }}
                    primary={label}
                  />
                </ListItem>
                {children && (
                  <Collapse
                    in={isOpen}
                    timeout="auto"
                    unmountOnExit
                    className={classes.nestedList}
                  >
                    <List component="div" disablePadding>
                      {/* {children.map(childrenLink => (
                        <SidebarLink
                          key={childrenLink && childrenLink.link}
                          location={location}                        
                          classes={classes}
                          nested
                          {...childrenLink}
                        />
                      ))} */}
{/*                       <ListaSoporte></ListaSoporte>
 */}                    </List>
                  </Collapse>
                )}
              </>
            );}
    // ###########################################################

    function toggleCollapse(e) {
        //if (isSidebarOpened) {
            e.preventDefault();
            setIsOpen(!isOpen);
        //}
    }
}

export default SidebarLink;